import { TokenService } from './token.service';
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TokenResolver implements Resolve<any> {
    constructor(private tokenService: TokenService) {}

    resolve() {
        return this.tokenService.initializeToken();
    }
}
